import { Avatar, AvatarFallback, AvatarImage } from '@components/ui/avatar';
import { imgAssets } from '@utils/img-assets';
import { FC } from 'react';
import { cn } from '@utils/cn';

const LOGO_URL = imgAssets.brand.logo;

type LqdLogoProps = {
  title?: string;
  imgUrl?: string;
  size?: 'sm' | 'md' | 'lg';
  square?: boolean;
  renderTitle?: boolean;
};

const LqdLogo: FC<LqdLogoProps> = ({
  title = 'Lqd',
  imgUrl = LOGO_URL,
  size = 'sm',
  square = false,
  renderTitle = true
}) => {
  return (
    <div className="flex items-center gap-4">
      <Avatar
        className={cn(
          square && 'rounded-sm',
          size === 'sm' && 'w-8 h-8',
          size === 'md' && 'w-10 h-10',
          size === 'lg' && 'w-12 h-12'
        )}
      >
        <AvatarImage src={imgUrl} alt="Lqd logo" />
        <AvatarFallback>Lqd</AvatarFallback>
      </Avatar>

      {renderTitle && (
        <span className="self-center text-xl font-semibold whitespace-nowrap dark:text-white">
          {title}
        </span>
      )}
    </div>
  );
};

export default LqdLogo;
